import gql from 'graphql-tag';

export const BOND_MATURITY_DIVERSIFICATION = gql`
    query BondMaturityDiversification($ticker: String!) {
        fund: mutualFund(ticker: $ticker) {
            inceptionDate
            maturities {
                name: maturityRangeDesc
                percentTotalNetAssets
                asOfDate
            }
        }
    }
`;

export const FI_ETF_BOND_MATURITY_DIVERSIFICATION = gql`
    query BondMaturity($ticker: String!) {
        fund: exchangeTradedFund(ticker: $ticker) {
            inceptionDate
            bondMaturity {
                asOfDate
                availableDates
                maturities: bondMaturityRatings {
                    name
                    percentOfFund
                    percentOfIndicativeBenchmark
                    percentOfUnderWeightOverWeight
                }
            }
        }
    }
`;
